import React from 'react';
import Icon from '../../icons/Icon';
import { HowItWorksLandingContent } from '../../../content/HowItWorksContent';

const HowItWorks = () => {
    const renderItems = () => {
        const iconDefaultSize = '80px';
        const style = { backgroundColor: '#DBF3F5' };

        const itemsRendered = [];
        for (let i = 0; i < HowItWorksLandingContent.length; i++) {
            itemsRendered.push(
                <div className="app__grid__column__three-one padding-sides-20" key={i}>
                    <div className="app__how-it-works__icon">
                        <Icon
                            icon={HowItWorksLandingContent[i].icon}
                            size={iconDefaultSize}
                            style={style}
                        />
                    </div>
                    <div className="semi-bold">
                        <span className="semi-bold">{i + 1}. </span>
                        {HowItWorksLandingContent[i].header}
                    </div>
                    <div className="app__how-it-works__info font-lighter">
                        {HowItWorksLandingContent[i].step === 1 ? (
                            <div>
                                It's free and takes just 60 seconds! Simply tell us what you're
                                looking for and we'll do the rest. Or, if you prefer, you can{' '}
                                <a
                                    href="https://www.vouchedfor.co.uk/"
                                    target="_blank"
                                    rel="noreferrer">
                                    search our directory
                                </a>
                            </div>
                        ) : (
                            HowItWorksLandingContent[i].text
                        )}
                    </div>
                </div>
            );
        }
        return itemsRendered;
    };

    return (
        <div className="app__landing-page__section how-it-works matching">
            <div className="how-it-works__container">
                <h5 className="vouchedfor-brand">How it works</h5>
                <div className="under-title"></div>
                <div className="app__how-it-works__list">{renderItems()}</div>
            </div>
        </div>
    );
};

export default HowItWorks;
